import { render, staticRenderFns } from "./AddSuperBonus.vue?vue&type=template&id=627761a2"
import script from "./AddSuperBonus.vue?vue&type=script&lang=js"
export * from "./AddSuperBonus.vue?vue&type=script&lang=js"
import style0 from "./AddSuperBonus.vue?vue&type=style&index=0&id=627761a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports